import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
import { BRAND } from './salesData';
const CONTACTS = [{
  icon: MailIcon,
  label: 'Soporte y consultas',
  value: BRAND.email,
  href: `mailto:${BRAND.email}`,
  external: false
}, {
  icon: InstagramIcon,
  label: 'Instagram',
  value: BRAND.instagramHandle,
  href: BRAND.instagramUrl,
  external: true
}, {
  icon: GlobeIcon,
  label: 'Sitio oficial',
  value: BRAND.siteLabel,
  href: BRAND.siteUrl,
  external: true
}];
export function Footer() {
  return <footer id="site-footer" className="border-t border-warm bg-ivory py-12" data-id="element-85" data-mp="3lec7k9t840dr">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-8" data-id="element-86" data-mp="3lggfd2u8tjjb">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between sm:gap-12" data-id="element-87" data-mp="3qc40n75ltsjj">
          <div data-id="element-88" data-mp="29ydxc2mb78ay">
            <p className="font-display text-lg tracking-tight text-charcoal" data-id="element-89" data-mp="29xvrce9uhfpu">
              SISTEMA <span className="text-gold-deep" data-id="element-90" data-mp="2ezuvhqdesgnu">IA</span>
            </p>
            <p className="mt-1.5 font-sans text-[0.84rem] text-charcoal/55" data-id="element-91" data-mp="3l8qwo57filrz">
              Para nutricionistas · Producto 100% digital
            </p>
            <p className="mt-5 font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-charcoal/40" data-id="element-92" data-mp="3gck1n7gkmuot">
              Un producto de
            </p>
            <p className="mt-1 font-display text-[0.95rem] uppercase tracking-tight text-charcoal" data-id="element-93" data-mp="3q7llbns2v4k0">
              {BRAND.studio}
            </p>
          </div>

          <ul className="grid gap-4 sm:grid-cols-3 sm:gap-x-10" data-id="element-94" data-mp="33xge4qruavo">
            {CONTACTS.map(contact => {
            const Icon = contact.icon;
            return <li key={contact.href} data-id="element-95" data-mp="huwhkupa1x58">
                  <p className="font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-charcoal/40" data-id="element-96" data-mp="ct77bh9vpni7">
                    {contact.label}
                  </p>
                  <a href={contact.href} {...contact.external ? {
                target: '_blank',
                rel: 'noopener noreferrer'
              } : {}} className="mt-1.5 inline-flex items-center gap-2 font-sans text-[0.85rem] font-medium text-charcoal/75 transition-colors duration-200 ease-out hover:text-gold-deep" data-id="element-97" data-mp="qr5lalkafhx6">
                    <Icon className="h-4 w-4 shrink-0 text-gold-deep" aria-hidden data-id="element-98" data-mp="18jqznv3knfs0" />
                    <span className="break-all" data-id="element-99" data-mp="18lu1rdi00zd3">{contact.value}</span>
                  </a>
                </li>;
          })}
          </ul>
        </div>

        <div className="mt-10 border-t border-warm pt-6" data-id="element-100" data-mp="1hj49wpzis8ds">
          <p className="max-w-3xl font-sans text-[0.72rem] leading-relaxed text-charcoal/40" data-id="element-101" data-mp="1mj8uos7gnp9t">
            El Sistema IA para Nutricionistas es una herramienta de asistencia y productividad
            profesional. No reemplaza el criterio, diagnóstico ni indicación del nutricionista.
          </p>
          <p className="mt-4 font-sans text-[0.72rem] text-charcoal/40" data-id="element-102" data-mp="3t9q3pthhx4pc">
            © 2026 {BRAND.studio}. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}